import { getExamsHistoryThunk } from '../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../store/store';
import { setJobBoxTab } from '../../../store/workspace/slice';
import { selectUserId } from '../../../store/auth/selectors';
import JobApplications from './containers/JobApplications';
import WelcomeBox from './components/WelcomeBox';
import InfoCard from './components/InfoCard';
import styles from './style.module.scss';
import JobBox from './containers/JobBox';
import { useEffect } from 'react';
import {
    selectMatchedJobs,
    selectProfileData,
    selectExamsHistory,
} from '../../../store/workspace/selectors';
import {
    CheckSquareIcon,
    CodeSquareIcon,
    ProfileSquareIcon,
    RecruitingInterviewIcon,
    StarSquareIcon,
} from '../../../assets/icons/common';

function Dashboard() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const jobs = useSelector(selectMatchedJobs);
    const history = useSelector(selectExamsHistory);
    const profileData = useSelector(selectProfileData);
    const disabledMatching = !profileData?.setting?.seeking || false;
    const codingExams = history.filter(i => i.status === 'codingExam');
    const recruitingInterviewList = jobs.filter(i => i.status === 'recruitingInterview');
    const multipleChoiceExamsList = jobs.filter(i => i.status === 'multipleChoiceExam');
    const interviewList = history.filter(i => i.status === 'interview');
    const finalResultList = history.filter(i => i.status === 'finalResult');

    useEffect(() => {
        if (!userId) return;
        dispatch(getExamsHistoryThunk(userId));
    }, [userId]);

    return (
        <div className={styles.container}>
            <div className={styles.main}>
                <div className={styles.infoCardWrapper}>
                    <InfoCard
                        title='Recruiting interview'
                        icon={<RecruitingInterviewIcon />}
                        value={`${recruitingInterviewList.length}`}
                        onClick={() => dispatch(setJobBoxTab('RecruitingInterview'))}
                    />
                    <InfoCard
                        title='Multiple choice'
                        icon={<CheckSquareIcon />}
                        value={`${multipleChoiceExamsList.length}`}
                        onClick={() => dispatch(setJobBoxTab('MultipleChoice'))}
                    />
                    <InfoCard
                        title='Coding exam'
                        icon={<CodeSquareIcon />}
                        value={`${codingExams.length}`}
                        onClick={() => dispatch(setJobBoxTab('Coding'))}
                    />
                    <InfoCard
                        title='Personal interview'
                        icon={<ProfileSquareIcon />}
                        value={`${interviewList.length}`}
                        onClick={() => dispatch(setJobBoxTab('Interview'))}
                    />
                    <InfoCard
                        title='Final result'
                        icon={<StarSquareIcon />}
                        value={`${finalResultList.length}`}
                        onClick={() => dispatch(setJobBoxTab('FinalResult'))}
                    />
                </div>
                {!(profileData?.matchedJobs && history) ?
                    <WelcomeBox /> :
                    <JobBox
                        disabledMatching={disabledMatching}
                        matchedJobs={profileData?.matchedJobs}
                    />}
            </div>
            <JobApplications />
        </div>
    );
};

export default Dashboard;
